import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme: any) => ({
  root: {
    width: '100%',
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    background: theme.backgrounds.cardBackground,
    borderRadius: '5px',
    padding: '24px 24px 24px 70px',
    position: 'relative',
    marginBottom: -8,
  },
  radioButton: {
    position: 'absolute',
    left: 22,
    top: 'calc(50% - 21px)',
  },
  cardMobile: {
    padding: 18,
  },
  cardDescription: {},
}))

export default useStyles
